import _ from "lodash";
import set from "@rill/set";
import GymLocations from "./gym-locations/gym-locations";
import NewGymComponent from "./gym-locations/new-gym";
import EditGymComponent from "./gym-locations/edit-gym";
import { GymModalComponent } from "./gym-locations/gym-modal";
import { getUserToRequest } from "./manage-coaches/utils/manage-coaches-utils";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

module.exports = (app) => {
  app
    .get(
      "/gym-locations",
      set("heading", "Edit Gym Locations"),
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin"]
        ),
      ({ locals, res, req }) => {
        const { query = {} } = req;
        const modal = query.modal || {};
        const { activeUser, organizationOwner } = locals;
        const userToRequest = getUserToRequest(activeUser, organizationOwner);
        const { pressCustomBranding = {} } = userToRequest;
        const gymLocations =
          !!pressCustomBranding && !!pressCustomBranding.gymLocations
            ? pressCustomBranding.gymLocations
            : [];

        //set active gym location
        if (
          query.gymLong &&
          query.gymLat &&
          query.gymContact &&
          gymLocations.length > 0
        ) {
          locals.activeGymLocation = gymLocations.find(
            ({ gymCoordinates, gymContact }) =>
              String(gymContact) === String(query.gymContact) &&
              String(gymCoordinates.long) === String(query.gymLong) &&
              String(gymCoordinates.lat) === String(query.gymLat)
          );
        }

        //load modal
        locals.modal = {
          "watch-gym-detail": <GymModalComponent locals={locals} />,
          "activity-feed": <ActivityDrawer />,
        }[modal.type];

        //load componentes
        res.body =
          locals.query && locals.query.addNewGym ? (
            <NewGymComponent />
          ) : locals.query && query.editingGym ? (
            <EditGymComponent locals={locals} />
          ) : (
            <GymLocations locals={locals} gymLocations={gymLocations} />
          );
      }
    )
    .post(
      "/gym-locations",
      (ctx, next) =>
        checkOrganizationSectionPermission(
          ctx,
          next,
          "settings",
          "/coaching-portal/settings",
          ["Owner", "Admin"]
        ),
      async ({ req, locals, res, api, flash, assert, momentTZ }) => {
        const { body, query = {} } = req;
        const { activeUser, organizationOwner } = locals;
        const userToRequest = getUserToRequest(activeUser, organizationOwner);
        const { pressCustomBranding = {} } = userToRequest;
        const newBody =
          body.requestType === "post"
            ? handlePost(body, pressCustomBranding)
            : handlePut(body, pressCustomBranding, query);

        try {
          assert(
            !newBody.error,
            400,
            "This facilikey is already linked to another gym"
          );

          await api(`user/${userToRequest._id}`, {
            method: "PUT",
            body: newBody,
          });
          flash("success", "Gym location added successfully.");
          res.redirect("/coaching-portal/settings/gym-locations");
        } catch (e) {
          flash("error", e.message);
          res.redirect("/coaching-portal/settings/gym-locations");
          res.backDontScroll();
        }
      }
    );

  /**
   * add gym location
   * @param {*} body
   * @param {*} pressCustomBranding
   * @returns
   */
  const handlePost = (body, pressCustomBranding) => {
    const {
      facilikey = "",
      gymMapLink = "",
      gymName = "",
      gymEmail = "",
      gymContact = "",
      gymLocation = "",
      daysWithSameAsAbove = "",
      workingDays = "",
      endHoursOfOperationOfFriday = "",
      endHoursOfOperationOfMonday = "",
      endHoursOfOperationOfSaturday = "",
      endHoursOfOperationOfTuesday = "",
      endHoursOfOperationOfWednesday = "",
      endHoursStaffHoursOfFriday = "",
      endHoursStaffHoursOfMonday = "",
      endHoursStaffHoursOfSaturday = "",
      endHoursStaffHoursOfTuesday = "",
      endHoursStaffHoursOfWednesday = "",
      initHoursOfOperationOfFriday = "",
      initHoursOfOperationOfMonday = "",
      initHoursOfOperationOfSaturday = "",
      initHoursOfOperationOfTuesday = "",
      initHoursOfOperationOfWednesday = "",
      initHoursStaffHoursOfFriday = "",
      initHoursStaffHoursOfMonday = "",
      initHoursStaffHoursOfSaturday = "",
      initHoursStaffHoursOfTuesday = "",
      initHoursStaffHoursOfWednesday = "",
      initHoursStaffHoursOfSunday = "",
      initHoursOfOperationOfSunday = "",
      endHoursStaffHoursOfSunday = "",
      endHoursOfOperationOfSunday = "",
      initHoursStaffHoursOfThursday = "",
      initHoursOfOperationOfThursday = "",
      endHoursStaffHoursOfThursday = "",
      endHoursOfOperationOfThursday = "",
    } = body;

    let newBody = {};
    let gymLocations =
      pressCustomBranding && pressCustomBranding.gymLocations
        ? pressCustomBranding.gymLocations
        : [];

    const bodyFormatting = bodyFormattingOject(
      gymName,
      gymContact,
      gymEmail,
      gymLocation,
      gymMapLink,
      facilikey,
      daysWithSameAsAbove,
      workingDays,
      initHoursStaffHoursOfMonday,
      initHoursOfOperationOfMonday,
      endHoursStaffHoursOfMonday,
      endHoursOfOperationOfMonday,
      initHoursStaffHoursOfTuesday,
      initHoursOfOperationOfTuesday,
      endHoursStaffHoursOfTuesday,
      endHoursOfOperationOfTuesday,
      initHoursStaffHoursOfWednesday,
      initHoursOfOperationOfWednesday,
      endHoursStaffHoursOfWednesday,
      endHoursOfOperationOfWednesday,
      initHoursStaffHoursOfThursday,
      initHoursOfOperationOfThursday,
      endHoursStaffHoursOfThursday,
      endHoursOfOperationOfThursday,
      initHoursStaffHoursOfFriday,
      initHoursOfOperationOfFriday,
      endHoursStaffHoursOfFriday,
      endHoursOfOperationOfFriday,
      initHoursStaffHoursOfSaturday,
      initHoursOfOperationOfSaturday,
      endHoursStaffHoursOfSaturday,
      endHoursOfOperationOfSaturday,
      initHoursStaffHoursOfSunday,
      initHoursOfOperationOfSunday,
      endHoursStaffHoursOfSunday,
      endHoursOfOperationOfSunday
    );

    const repeatedFacilikey = gymLocations.find(
      (item) => item.facilikey === facilikey
    );

    // if (repeatedFacilikey) {
    //   newBody = {
    //     error: "repeated",
    //   };
    // } else {
    gymLocations.push(bodyFormatting);
    newBody.pressCustomBranding = Object.assign({}, pressCustomBranding);
    newBody.pressCustomBranding.gymLocations = gymLocations;
    //  }

    return newBody;
  };

  /**
   * Edit gym location
   * @param {*} body
   * @param {*} pressCustomBranding
   * @param {*} query
   * @returns
   */
  const handlePut = (body, pressCustomBranding, query) => {
    const {
      facilikey = "",
      gymMapLink = "",
      gymName = "",
      gymContact = "",
      gymEmail = "",
      gymLocation = "",
      daysWithSameAsAbove = "",
      workingDays = "",
      endHoursOfOperationOfFriday = "",
      endHoursOfOperationOfMonday = "",
      endHoursOfOperationOfSaturday = "",
      endHoursOfOperationOfTuesday = "",
      endHoursOfOperationOfWednesday = "",
      endHoursStaffHoursOfFriday = "",
      endHoursStaffHoursOfMonday = "",
      endHoursStaffHoursOfSaturday = "",
      endHoursStaffHoursOfTuesday = "",
      endHoursStaffHoursOfWednesday = "",
      initHoursOfOperationOfFriday = "",
      initHoursOfOperationOfMonday = "",
      initHoursOfOperationOfSaturday = "",
      initHoursOfOperationOfTuesday = "",
      initHoursOfOperationOfWednesday = "",
      initHoursStaffHoursOfFriday = "",
      initHoursStaffHoursOfMonday = "",
      initHoursStaffHoursOfSaturday = "",
      initHoursStaffHoursOfTuesday = "",
      initHoursStaffHoursOfWednesday = "",
      initHoursStaffHoursOfSunday = "",
      initHoursOfOperationOfSunday = "",
      endHoursStaffHoursOfSunday = "",
      endHoursOfOperationOfSunday = "",
      initHoursStaffHoursOfThursday = "",
      initHoursOfOperationOfThursday = "",
      endHoursStaffHoursOfThursday = "",
      endHoursOfOperationOfThursday = "",
    } = body;

    let newBody = {};
    let gymLocations =
      pressCustomBranding && pressCustomBranding.gymLocations
        ? pressCustomBranding.gymLocations
        : [];

    const bodyFormatting = bodyFormattingOject(
      gymName,
      gymContact,
      gymEmail,
      gymLocation,
      gymMapLink,
      facilikey,
      daysWithSameAsAbove,
      workingDays,
      initHoursStaffHoursOfMonday,
      initHoursOfOperationOfMonday,
      endHoursStaffHoursOfMonday,
      endHoursOfOperationOfMonday,
      initHoursStaffHoursOfTuesday,
      initHoursOfOperationOfTuesday,
      endHoursStaffHoursOfTuesday,
      endHoursOfOperationOfTuesday,
      initHoursStaffHoursOfWednesday,
      initHoursOfOperationOfWednesday,
      endHoursStaffHoursOfWednesday,
      endHoursOfOperationOfWednesday,
      initHoursStaffHoursOfThursday,
      initHoursOfOperationOfThursday,
      endHoursStaffHoursOfThursday,
      endHoursOfOperationOfThursday,
      initHoursStaffHoursOfFriday,
      initHoursOfOperationOfFriday,
      endHoursStaffHoursOfFriday,
      endHoursOfOperationOfFriday,
      initHoursStaffHoursOfSaturday,
      initHoursOfOperationOfSaturday,
      endHoursStaffHoursOfSaturday,
      endHoursOfOperationOfSaturday,
      initHoursStaffHoursOfSunday,
      initHoursOfOperationOfSunday,
      endHoursStaffHoursOfSunday,
      endHoursOfOperationOfSunday
    );

    const repeatedFacilikey = gymLocations.find(
      (item) => item.facilikey === facilikey
    );

    gymLocations.forEach((element, index) => {
      if (
        String(element.gymCoordinates.long) === String(query.gymLong) &&
        String(element.gymCoordinates.lat) === String(query.gymLat) &&
        String(element.gymContact) === String(query.gymContact)
      ) {
        gymLocations[index] = bodyFormatting;
      }
    });
    newBody.pressCustomBranding = Object.assign({}, pressCustomBranding);
    newBody.pressCustomBranding.gymLocations = gymLocations;
    return newBody;
  };

  /**
   * Format the body object
   * @param {*} gymName
   * @param {*} gymContact
   * @param {*} gymEmail
   * @param {*} gymLocation
   * @param {*} gymMapLink
   * @param {*} facilikey
   * @param {*} daysWithSameAsAbove
   * @param {*} workingDays
   * @param {*} initHoursStaffHoursOfMonday
   * @param {*} initHoursOfOperationOfMonday
   * @param {*} endHoursStaffHoursOfMonday
   * @param {*} endHoursOfOperationOfMonday
   * @param {*} initHoursStaffHoursOfTuesday
   * @param {*} initHoursOfOperationOfTuesday
   * @param {*} endHoursStaffHoursOfTuesday
   * @param {*} endHoursOfOperationOfTuesday
   * @param {*} initHoursStaffHoursOfWednesday
   * @param {*} initHoursOfOperationOfWednesday
   * @param {*} endHoursStaffHoursOfWednesday
   * @param {*} endHoursOfOperationOfWednesday
   * @param {*} initHoursStaffHoursOfThursday
   * @param {*} initHoursOfOperationOfThursday
   * @param {*} endHoursStaffHoursOfThursday
   * @param {*} endHoursOfOperationOfThursday
   * @param {*} initHoursStaffHoursOfFriday
   * @param {*} initHoursOfOperationOfFriday
   * @param {*} endHoursStaffHoursOfFriday
   * @param {*} endHoursOfOperationOfFriday
   * @param {*} initHoursStaffHoursOfSaturday
   * @param {*} initHoursOfOperationOfSaturday
   * @param {*} endHoursStaffHoursOfSaturday
   * @param {*} endHoursOfOperationOfSaturday
   * @param {*} initHoursStaffHoursOfSunday
   * @param {*} initHoursOfOperationOfSunday
   * @param {*} endHoursStaffHoursOfSunday
   * @param {*} endHoursOfOperationOfSunday
   * @returns
   */
  const bodyFormattingOject = (
    gymName,
    gymContact,
    gymEmail,
    gymLocation,
    gymMapLink,
    facilikey,
    daysWithSameAsAbove,
    workingDays,
    initHoursStaffHoursOfMonday,
    initHoursOfOperationOfMonday,
    endHoursStaffHoursOfMonday,
    endHoursOfOperationOfMonday,
    initHoursStaffHoursOfTuesday,
    initHoursOfOperationOfTuesday,
    endHoursStaffHoursOfTuesday,
    endHoursOfOperationOfTuesday,
    initHoursStaffHoursOfWednesday,
    initHoursOfOperationOfWednesday,
    endHoursStaffHoursOfWednesday,
    endHoursOfOperationOfWednesday,
    initHoursStaffHoursOfThursday,
    initHoursOfOperationOfThursday,
    endHoursStaffHoursOfThursday,
    endHoursOfOperationOfThursday,
    initHoursStaffHoursOfFriday,
    initHoursOfOperationOfFriday,
    endHoursStaffHoursOfFriday,
    endHoursOfOperationOfFriday,
    initHoursStaffHoursOfSaturday,
    initHoursOfOperationOfSaturday,
    endHoursStaffHoursOfSaturday,
    endHoursOfOperationOfSaturday,
    initHoursStaffHoursOfSunday,
    initHoursOfOperationOfSunday,
    endHoursStaffHoursOfSunday,
    endHoursOfOperationOfSunday
  ) => {
    const { lat, long } = getGymCoordinates(gymMapLink);
    const bodyFormatting = {
      gymName,
      gymContact,
      gymEmail,
      gymLocation,
      gymMapLink,
      facilikey,
      daysWithSameAsAbove,
      workingDays,
      gymCoordinates: {
        lat,
        long,
      },
      days: [
        {
          day: "Monday",
          status: workingDays.includes("Monday"),
          initHoursStaffHours: initHoursStaffHoursOfMonday,
          initHoursOfOperation: initHoursOfOperationOfMonday,
          endHoursStaffHours: endHoursStaffHoursOfMonday,
          endHoursOfOperation: endHoursOfOperationOfMonday,
        },
        {
          day: "Tuesday",
          status: workingDays.includes("Tuesday"),
          initHoursStaffHours: initHoursStaffHoursOfTuesday,
          initHoursOfOperation: initHoursOfOperationOfTuesday,
          endHoursStaffHours: endHoursStaffHoursOfTuesday,
          endHoursOfOperation: endHoursOfOperationOfTuesday,
        },
        {
          day: "Wednesday",
          status: workingDays.includes("Wednesday"),
          initHoursStaffHours: initHoursStaffHoursOfWednesday,
          initHoursOfOperation: initHoursOfOperationOfWednesday,
          endHoursStaffHours: endHoursStaffHoursOfWednesday,
          endHoursOfOperation: endHoursOfOperationOfWednesday,
        },
        {
          day: "Thursday",
          status: workingDays.includes("Thursday"),
          initHoursStaffHours: initHoursStaffHoursOfThursday,
          initHoursOfOperation: initHoursOfOperationOfThursday,
          endHoursStaffHours: endHoursStaffHoursOfThursday,
          endHoursOfOperation: endHoursOfOperationOfThursday,
        },
        {
          day: "Friday",
          status: workingDays.includes("Friday"),
          initHoursStaffHours: initHoursStaffHoursOfFriday,
          initHoursOfOperation: initHoursOfOperationOfFriday,
          endHoursStaffHours: endHoursStaffHoursOfFriday,
          endHoursOfOperation: endHoursOfOperationOfFriday,
        },
        {
          day: "Saturday",
          status: workingDays.includes("Saturday"),
          initHoursStaffHours: initHoursStaffHoursOfSaturday,
          initHoursOfOperation: initHoursOfOperationOfSaturday,
          endHoursStaffHours: endHoursStaffHoursOfSaturday,
          endHoursOfOperation: endHoursOfOperationOfSaturday,
        },
        {
          day: "Sunday",
          status: workingDays.includes("Sunday"),
          initHoursStaffHours: initHoursStaffHoursOfSunday,
          initHoursOfOperation: initHoursOfOperationOfSunday,
          endHoursStaffHours: endHoursStaffHoursOfSunday,
          endHoursOfOperation: endHoursOfOperationOfSunday,
        },
      ],
    };
    return bodyFormatting;
  };
};

const getGymCoordinates = (gymMapLink) => {
  let lat = "0";
  let long = "0";
  //Regular expression to find the string that contains the coordinates
  const regex = /@([-0-9.]+),([-0-9.]+)/;

  // find the string that contains the coordinates using the regular expression
  const match = gymMapLink.match(regex);

  lat = match[1].slice(0, 7); //get the first seven characters (mapbox suggest)
  long = match[2].slice(0, 8); //get the first eight characters (mapbox suggest)

  return { lat, long };
};

export const initBlankState = {
  endHoursOfOperationOfFriday: "",
  endHoursOfOperationOfMonday: "",
  endHoursOfOperationOfSaturday: "",
  endHoursOfOperationOfSunday: "",
  endHoursOfOperationOfThursday: "",
  endHoursOfOperationOfTuesday: "",
  endHoursOfOperationOfWednesday: "",
  endHoursStaffHoursOfFriday: "",
  endHoursStaffHoursOfMonday: "",
  endHoursStaffHoursOfSaturday: "",
  endHoursStaffHoursOfSunday: "",
  endHoursStaffHoursOfThursday: "",
  endHoursStaffHoursOfTuesday: "",
  endHoursStaffHoursOfWednesday: "",
  initHoursOfOperationOfFriday: "",
  initHoursOfOperationOfMonday: "",
  initHoursOfOperationOfSaturday: "",
  initHoursOfOperationOfSunday: "",
  initHoursOfOperationOfThursday: "",
  initHoursOfOperationOfTuesday: "",
  initHoursOfOperationOfWednesday: "",
  initHoursStaffHoursOfFriday: "",
  initHoursStaffHoursOfMonday: "",
  initHoursStaffHoursOfSaturday: "",
  initHoursStaffHoursOfSunday: "",
  initHoursStaffHoursOfThursday: "",
  initHoursStaffHoursOfTuesday: "",
  initHoursStaffHoursOfWednesday: "",
  gymName: "",
  gymContact: "",
  gymEmail: "",
  facilikey: "",
  gymLocation: "",
  gymMapLink: "",
};
